import { Chip, Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { useStyles } from './skills.style';

type SkillsProps = {
    skills: string[];
};

export const Skills: React.FC<SkillsProps> = ({ skills }) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Grid container className={classes.summary}>
            <Typography variant="body1" className={classes.sectionTitle}>
                {t('jobDetails:keySkills')}
            </Typography>
            {skills.map((skill, index) => (
                <Chip
                    style={{ marginRight: 8, marginBottom: 8 }}
                    key={index}
                    label={skill}
                    color="primary"
                    variant="outlined"
                />
            ))}
        </Grid>
    );
};
